import * as React from "react";
const IconShoppingBasket = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M56.4 19.6H54L47.5 3.2C47 2 45.7 1.5 44.6 1.9c-1.2.5-1.7 1.8-1.3 2.9l5.8 14.8H14.9l5.8-14.7c.5-1.2-.1-2.5-1.3-2.9-1.1-.5-2.4 0-2.9 1.2L10 19.6H7.6c-1.8 0-3.3 1.5-3.3 3.3V31c0 1.7 1.2 3 2.9 3.2L9.7 56c.4 3.6 3.4 6.3 7 6.3h30.6c3.6 0 6.6-2.7 7-6.3l2.5-21.8c1.6-.2 2.9-1.6 2.9-3.2v-8.2c0-1.8-1.5-3.2-3.3-3.2M8.8 24.1h46.4v5.7H8.8zm38.5 33.7H16.7c-1.3 0-2.4-1-2.6-2.3l-2.4-21.2h40.6l-2.4 21.2c-.2 1.3-1.3 2.3-2.6 2.3" />
    <path d="M21.8 38.8c-1.2 0-2.3 1-2.3 2.3v7.5c0 1.2 1 2.3 2.3 2.3s2.3-1 2.3-2.3V41c0-1.2-1-2.2-2.3-2.2M42.2 38.8c-1.2 0-2.3 1-2.3 2.3v7.5c0 1.2 1 2.3 2.3 2.3s2.3-1 2.3-2.3V41c-.1-1.2-1.1-2.2-2.3-2.2" />
  </svg>
);
export default IconShoppingBasket;
